/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrated HCl (density 1.18 g/mL, assay 37%, EW 36.46): N = 10 × 1.18 × 37 / 36.46 ≈ 11.97 N.`)
};

const es_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HCl concentrado (densidad 1.18 g/mL, ensayo 37%, PE 36.46): N = 10 × 1.18 × 37 / 36.46 ≈ 11.97 N.`)
};

const de_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konzentrierte HCl (Dichte 1,18 g/mL, Gehalt 37%, EW 36,46): N = 10 × 1,18 × 37 / 36,46 ≈ 11,97 N.`)
};

const nl_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geconcentreerd HCl (dichtheid 1,18 g/mL, gehalte 37%, EW 36,46): N = 10 × 1,18 × 37 / 36,46 ≈ 11,97 N.`)
};

const fr_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HCl concentré (densité 1,18 g/mL, titre 37 %, EG 36,46) : N = 10 × 1,18 × 37 / 36,46 ≈ 11,97 N.`)
};

const it_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HCl concentrato (densità 1,18 g/mL, titolo 37%, PE 36,46): N = 10 × 1,18 × 37 / 36,46 ≈ 11,97 N.`)
};

const pt_br2_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HCl concentrado (densidade 1,18 g/mL, teor 37%, PE 36,46): N = 10 × 1,18 × 37 / 36,46 ≈ 11,97 N.`)
};

const pt_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HCl concentrado (densidade 1,18 g/mL, título 37%, EG 36,46): N = 10 × 1,18 × 37 / 36,46 ≈ 11,97 N.`)
};

const ja_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`濃塩酸 (密度1.18 g/mL、アッセイ37%、当量36.46): N = 10 × 1.18 × 37 / 36.46 ≈ 11.97 N。`)
};

const zh_norm_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浓盐酸（密度 1.18 g/mL，含量 37%，当量重量 36.46）：N = 10 × 1.18 × 37 / 36.46 ≈ 11.97 N。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_ex1", locale)
	if (locale === "en") return en_norm_ex1(inputs)
	if (locale === "es") return es_norm_ex1(inputs)
	if (locale === "de") return de_norm_ex1(inputs)
	if (locale === "nl") return nl_norm_ex1(inputs)
	if (locale === "fr") return fr_norm_ex1(inputs)
	if (locale === "it") return it_norm_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_norm_ex1(inputs)
	if (locale === "pt") return pt_norm_ex1(inputs)
	if (locale === "ja") return ja_norm_ex1(inputs)
	return zh_norm_ex1(inputs)
};